import { useEffect, useRef, useState } from "react";

/**
 * Reveals an element when it scrolls into view.
 * Adds the `is-visible` class for CSS transition.
 */
export default function useReveal(options = {}) {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        if (visible) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setVisible(true);
                        el.classList.add("is-visible");
                        observer.unobserve(el);
                    }
                });
            },
            { threshold: 0.15, rootMargin: "0px 0px -40px 0px", ...options }
        );

        observer.observe(el);
        return () => observer.disconnect();
    }, [visible, options]);

    return ref;
}
